import React from "react";

// STYLES
import "./applyTimer.css";

// TIMER
import moment from "moment";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";

export default class ApplyTimer extends React.PureComponent {
  render() {
    const { id, number, onChange, i18n, placeholder, disabled } = this.props;

    let lng = i18n.language;
    moment.lang(lng);

    const defaultValue = moment().startOf("day");

    return (
      <TimePicker
        placeholder={placeholder}
        showSecond={false}
        className="timer"
        onChange={(value, _id, _number) => onChange(value, id, number)}
        use12Hours={lng === "pt" ? false : true}
        minuteStep={15}
        disabled={disabled}
        defaultValue={defaultValue}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/applyTimer/applyTimer.component.js